import React from 'react'

const ErrorComponent = () => {
  return (
    <div>Something Went Wrong</div>
  )
}

export default ErrorComponent